/**
 * US phone number auto-formatter.
 * Formats input as: +1 (XXX) XXX-XXXX
 */
export const formatPhone = (value) => {
  // Strip all non-digit characters
  const digits = (value || '').replace(/\D/g, '');

  // Remove leading '1' country code if present (we'll add +1 prefix)
  const raw = digits.startsWith('1') && digits.length > 10 ? digits.slice(1) : digits;

  const len = raw.length;
  if (len === 0) return '';
  if (len <= 3) return `+1 (${raw}`;
  if (len <= 6) return `+1 (${raw.slice(0, 3)}) ${raw.slice(3)}`;
  return `+1 (${raw.slice(0, 3)}) ${raw.slice(3, 6)}-${raw.slice(6, 10)}`;
};

/**
 * Construct a display name from an object with firstName, lastName, middleInitial fields.
 * Returns "FirstName MI. LastName" or "FirstName LastName" if no MI.
 */
export const fullName = (obj) => {
  if (!obj) return '';
  const { firstName, lastName, middleInitial } = obj;
  const parts = [];
  if (firstName) parts.push(firstName);
  if (middleInitial) parts.push(`${middleInitial}.`);
  if (lastName) parts.push(lastName);
  return parts.join(' ') || '';
};

/**
 * Construct a full address string from split address fields.
 */
export const fullAddress = (obj) => {
  if (!obj) return '';
  const { street, city, state, zip, country } = obj;
  const parts = [street, city, state, zip, country].filter(Boolean);
  return parts.join(', ');
};

/**
 * US states list for dropdown.
 */
export const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA',
  'ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK',
  'OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY','DC'
];
